function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { components } from 'react-select';
import { Wrapper, Icon, SubLabel, Label, Text } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Option = function Option(_ref) {
  var children = _ref.children,
      innerProps = _ref.innerProps,
      props = _objectWithoutProperties(_ref, ["children", "innerProps"]);

  var isDisabled = props.data.disabled;
  var hasIcon = !!props.data.icon;
  var hasSubLabel = !!props.data.subLabel;
  var isFocused = props.isFocused;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(components.Option, _extends({
    key: "".concat(innerProps.id, "-").concat(props.value),
    id: innerProps.id
  }, props, {
    innerProps: innerProps,
    isDisabled: isDisabled
  }), ___EmotionJSX(Wrapper, null, hasIcon && ___EmotionJSX(Icon, null, props.data.icon), hasIcon ? ___EmotionJSX(Label, null, ___EmotionJSX(Text, null, children), hasSubLabel && ___EmotionJSX(SubLabel, {
    isFocused: isFocused
  }, props.data.subLabel)) : ___EmotionJSX(React.Fragment, null, children))));
};